module.exports = __webpack_public_path__ + "img/navigator-20.98b12445.jpg";